export default {
    category: {
        cta: "Ver produtos"
    }
}